class QuickBooksService {
    waysteAxios;
    constructor(waysteAxios) {
        this.waysteAxios = waysteAxios;
    }
    async authenticateQuickBooks() {
        return this.waysteAxios.mainInstance.get(`/quickbooks-connect/intuit-oauth`);
    }
    async status() {
        return (await this.waysteAxios.mainInstance.get(`/quickbooks-connect/intuit-oauth/status`)).data;
    }
    async disconnect() {
        return this.waysteAxios.mainInstance.delete(`/quickbooks-connect/intuit-oauth`);
    }
    async quickBooksCallback(searchParams) {
        return this.waysteAxios.mainInstance.get(`/quickbooks-connect/intuit-oauth/callback${searchParams}`);
    }
    async getQuickBooksMapping() {
        return this.waysteAxios.mainInstance.get(`/quickbooks-connect/mapping`);
    }
    async createQuickBooksMapping(data) {
        return this.waysteAxios.mainInstance.post(`/quickbooks-connect/mapping`, data);
    }
    async replaceQuickBooksMapping(data) {
        return this.waysteAxios.mainInstance.post(`/quickbooks-connect/mapping/replace`, data);
    }
    async deleteQuickBooksMapping(id) {
        return this.waysteAxios.mainInstance.delete(`/quickbooks-connect/mapping/${id}`);
    }
    async getQuickBooksSettings() {
        return this.waysteAxios.mainInstance.get(`/quickbooks-connect/settings`);
    }
    async updateQuickBooksSettings(data) {
        return this.waysteAxios.mainInstance.put(`/quickbooks-connect/settings`, data);
    }
    async quickBooksConnectItems() {
        return this.waysteAxios.mainInstance.get(`/quickbooks-connect/items`);
    }
    async quickBooksConnectAccounts() {
        return this.waysteAxios.mainInstance.get(`/quickbooks-connect/accounts`);
    }
    async generateQuickbooksDesktop(query) {
        return (await this.waysteAxios.mainInstance.get(`/quickbooks-connect/wayste/quickbooks-desktop`, {
            params: query,
        })).data;
    }
    async querySyncedDailyCount(query) {
        return (await this.waysteAxios.mainInstance.get(`/quickbooks-connect/admin-portal/quickbooks-online-daily`, {
            params: query,
        })).data;
    }
    async createQuickBooksDailyUpload(data) {
        return this.waysteAxios.mainInstance.patch(`/quickbooks-connect/admin-portal/quickbooks-online-daily`, data);
    }
}
export default QuickBooksService;
//# sourceMappingURL=QuickBooks.service.js.map